import { GET_LOGIN } from 'redux/actions/auth';
import { VALIDATION_ALL_STORE } from 'redux/actions/validationRole';

const initialState = {
  data: [],
  role: [],
  company: [],
  matrix: [],
};
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_LOGIN: {
      localStorage.setItem('token', payload.token);
      localStorage.setItem('company_id', payload.company.company_id);
      localStorage.setItem('company_name', payload.company.name);
      localStorage.setItem('member_id', payload.user_id);
      localStorage.setItem('user_level', payload.user_level);
      localStorage.setItem('name', payload.name);
      localStorage.setItem('pictCompany', payload.company.logo);
      localStorage.setItem('pictProfile', payload.profile);
      return {
        ...state,
        data: payload,
      };
    }
    case VALIDATION_ALL_STORE: {
      if (payload.type === 'dashboard') {
        return {
          ...state,
          role: payload,
        };
      } if (payload.type === 'company') {
        return {
          ...state,
          company: payload,
        };
      } if (payload.type === 'matrix') {
        return {
          ...state,
          matrix: payload,
        };
      }
      return {
        ...state,
        role: { ...payload },
      };
    }
    default:
      return state;
  }
};
